import Section from "../components/Section";
import {BottomNavigator} from "../components/Navbar";
import {useTranslation} from "react-i18next";
import {buildLocalizedImagePath} from "../utils";
import ScrollReveal from "../components/ScrollReveal";

const ComponentsPage = ({embedded = false}) => {
    const {t, i18n} = useTranslation();
    const language = i18n.language;
    const components00 = buildLocalizedImagePath(language, 'components/00');
    const components01 = buildLocalizedImagePath(language, 'components/01');
    const components02 = buildLocalizedImagePath(language, 'components/02');
    const components03 = buildLocalizedImagePath(language, 'components/03');
    const components04 = buildLocalizedImagePath(language, 'components/04');
    const components04a = buildLocalizedImagePath(language, 'components/04a');
    const components05 = buildLocalizedImagePath(language, 'components/05');

    return (
        <div className={'Page ComponentsPage'}>
            <Section className={'TopSection'}
                     id={'key-components'}
            >
                <ScrollReveal as={'div'} className={'TextContainer'} threshold={0.12} variant={'left'}>
                    <h1>
                        {t('components.title')}
                    </h1>
                    <p>
                        {t('components.description')}
                    </p>
                </ScrollReveal>
                <ScrollReveal as={'div'} className={'ImageContainer'} threshold={0.12} delay={100} variant={'right'}>
                    <img src={components00}/>
                </ScrollReveal>
            </Section>

            <Section className={'ComponentSection ComponentSection--01'}
                     id={'decentralized-blockchain'}
            >
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'left'}>{t('components.sections.01.heading')}</ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={60} variant={'up'}>
                        {t('components.sections.01.title')}
                    </ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={120} variant={'right'}>{t('components.sections.01.description')}</ScrollReveal>
                    <ScrollReveal as={'img'}
                                  src={components01}
                                  className={'ComponentSection__graphic ComponentSection--graphic01'}
                                  threshold={0.12}
                                  delay={160}
                                  variant={'scale'}
                    />
                </div>
            </Section>

            <Section className={'ComponentSection ComponentSection--02'}
                     id={'secure-data-storage'}>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'right'}>{t('components.sections.02.heading')}</ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={60} variant={'up'}>
                        {t('components.sections.02.title')}
                    </ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={120} variant={'left'}>{t('components.sections.02.description')}</ScrollReveal>
                    <ScrollReveal as={'img'}
                                  src={components02}
                                  className={'ComponentSection__graphic ComponentSection--graphic02'}
                                  threshold={0.12}
                                  delay={160}
                                  variant={'tilt-right'}
                    />
                </div>
            </Section>

            <Section className={'ComponentSection ComponentSection--03'}
                     id={'secure-computing'}>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'left'}>{t('components.sections.03.heading')}</ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={60} variant={'up'}>
                        {t('components.sections.03.title')}
                    </ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={120} variant={'right'}>{t('components.sections.03.description')}</ScrollReveal>
                    <ScrollReveal as={'img'}
                                  src={components03}
                                  className={'ComponentSection__graphic ComponentSection--graphic03'}
                                  threshold={0.12}
                                  delay={160}
                                  variant={'tilt-left'}
                    />
                </div>
            </Section>

            <Section className={'ComponentSection ComponentSection--04'}
                     id={'ai-powered-research'}>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'right'}>{t('components.sections.04.heading')}</ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={60} variant={'up'}>{t('components.sections.04.title')}</ScrollReveal>
                    <ScrollReveal as={'img'}
                                  src={components04}
                                  className={'ComponentSection__graphic ComponentSection--graphic04'}
                                  threshold={0.12}
                                  delay={120}
                                  variant={'scale'}
                    />
                    <ScrollReveal as={'h3'} threshold={0.12} delay={160} variant={'left'}>{t('components.sections.04.semantic_research_engine.title')}</ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={200} variant={'right'}>{t('components.sections.04.semantic_research_engine.description')}</ScrollReveal>
                    <ScrollReveal as={'img'}
                                  src={components04a}
                                  className={'ComponentSection__graphic ComponentSection--graphic04a'}
                                  threshold={0.12}
                                  delay={240}
                                  variant={'tilt-right'}
                    />
                    <ScrollReveal as={'h3'} threshold={0.12} delay={280} variant={'right'}>{t('components.sections.04.data_quality_check.title')}</ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={320} variant={'left'}>{t('components.sections.04.data_quality_check.description')}</ScrollReveal>

                </div>
            </Section>

            <Section className={'ComponentSection ComponentSection--05'}
                     id={'secure-key-management'}>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'left'}>{t('components.sections.05.heading')}</ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={60} variant={'up'}>
                        {t('components.sections.05.title')}
                    </ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={120} variant={'right'}>{t('components.sections.05.description')}</ScrollReveal>
                    <ScrollReveal as={'img'}
                                  src={components05}
                                  className={'ComponentSection__graphic ComponentSection--graphic05'}
                                  threshold={0.12}
                                  delay={160}
                                  variant={'scale'}
                    />
                </div>
            </Section>

            {
                !embedded &&
                <BottomNavigator
                    prev={{
                        to: '/platform',
                        title: t('navbar.platform')
                    }}
                    next={{
                        to: '/apps',
                        title: t('navbar.apps')
                    }}/>
            }
        </div>
    )
};

export default ComponentsPage;
